/* Reusable d3 force-directed layout for gene networks
 * Follows the design pattern suggested by Mike Bostock:
 * http://bost.ocks.org/mike/chart/
 */


(function() {

  module.exports = function(d3) {
//var d3 = require("d3");
    var options =
      {start_edge:0,
        start_color:"#2ca02c",
        mid_color:"#e7ba52",
        end_color:"#ca0020"};

    var force,
      zoom,
      edges = [],
      genes = [],
      gene_map = {},
      draw_genes = [],
      draw_edges = [],
      height,
      width,
      selection,
      svg,
      legend = false,
      edge_events = {},
      gene_events = {},
      bind_networks = [],
      gene_sets = [],
      fixed = false,
      inner_layout = false,
      outer_layout = false,
      degree_correct = false,
      event = d3.dispatch("edgeadd", "edgeremove",
        "geneadd", "generemove", "genechange", "start", "end");

    // Functions for network attributes
    var r = function(d) {return d.query ? 15 : Math.max(8,Math.min(3,d.query_degree*8));};
    var w = function(d) {return Math.max(1,d.weight*2.75);};
    var edgeColor = d3.scale.linear().domain([options.start_edge,.15,1])
      .range([options.start_color, options.mid_color, options.end_color]);
    var geneText = function(d) { return d.standard_name; };

    function my(_selection) {
      selection = _selection;

      if ( !width ) width = parseInt(selection.attr("width"));
      if ( !height) height = parseInt(selection.attr("height"));

      zoom = d3.behavior.zoom()
        .scaleExtent([.2,5])
        .on("zoom",zoomed);

      svg = selection;
      selection = selection.append("g")
        .call(zoom);

      selection.append("rect")
        .attr("class", "canvas")
        .attr("width",width)
        .attr("height",height)
        .style("fill","none")
        .style("pointer-events","all");

      selection = selection.append("g");

      var i,
        n = genes.length, m = edges.length,
        gene, edge;

      // Bind nodes to edges
      for (i = 0; i < m; ++i) {
        edge = edges[i];
        if (typeof edge.source == "number") edge.source = genes[edge.source];
        if (typeof edge.target == "number") edge.target = genes[edge.target];
      }

      // Calculate node degrees to query genes and all genes
      for( i = 0; i < n; i++ ) {
        gene = genes[i];
        gene.query_degree = 0;
        gene.query_degreen = 0;
        gene.degree = 0;
        gene.degreen = 0;
      }
      for( i = 0; i < m; i++ ) {
        edge = edges[i];
        if ( edge.source.query ) {
          edge.target.query_degree += edge.weight;
          edge.target.query_degreen ++;
        }
        if ( edge.target.query ) {
          edge.source.query_degree += edge.weight;
          edge.source.query_degreen ++;
        }
        edge.target.degree += edge.weight;
        edge.source.degree += edge.weight;
        edge.target.degreen ++;
        edge.source.degreen ++;
      }
      for( i = 0; i < n; i++ ) {
        genes[i].query_degree /= genes[i].query_degreen;
        genes[i].degree /= genes[i].degreen;
      }


      // Sort nodes according to background corrected degree
      // Store corresponding ranks
      if ( degree_correct ) {
        genes.sort(function(a,b){
          if(isNaN(a.query_degree))
            return -1
          else if(isNaN(b.query_degree))
            return 1
          else
            return b.query_degree/b.degree
              -a.query_degree/a.degree;})
      }
      else {
        genes.sort(function(a,b){
          if(isNaN(a.query_degree))
            return -1
          else if(isNaN(b.query_degree))
            return 1
          else
            return b.query_degree-a.query_degree;
        })
      }

      for( i = 0; i < n; i++ ) { genes[i].rank = i; }
    }


    function draw(genes, edges) {
      if ( typeof force != "undefined" ) force.stop();

      svg.select("rect.canvas")
        .attr("width",width)
        .attr("height",height);

      // transfrom edge data to path data for bezier rendering
      var bilinks = [], links = [], nodes = genes.slice();
      edges.forEach(function(edge) {
        var i = {};
        links.push(
          {source: edge.source, target: i, weight: edge.weight},
          {source: i, target: edge.target, weight: edge.weight});
        bilinks.push(Object.assign(edge, {inter:i}));
        nodes.push(i);
      });

      force = d3.layout.force()
        .charge(-200)
        .distance(50)
        .gravity(.15)
        .nodes(nodes)
        .links(links)
        .size([width, height]).start();

      var drag = force.drag()
        .origin(function(d){return d;})
        .on("dragstart", dragstarted)
        .on("drag", dragged)
        .on("dragend", dragended);

      var node_data = selection.selectAll("g.gene-group")
        .data(genes, function(d) { return d.id; });
      var link_data = selection.selectAll("path.edge")
        .data(bilinks, function(d) { return d.id; });

      var link_rm = link_data.exit().remove();
      var link = link_data
        .enter().insert("svg:path", "g")
        .attr("class", "edge")
        .on("mouseover", linkMouseover)
        .on("mouseout", linkMouseout)
        .attr("id", function(d) { return d.id; })
        .style("stroke", function(d) {return edgeColor(d.weight);})
        .style("fill", "none")
        .style("stroke-width", w);
      for( var type in edge_events ) link.on(type, edge_events[type]);
      event.edgeadd(link.filter(function(d){return d;}));
      event.edgeremove(link_rm.filter(function(d){return d;}));

      var node_rm = node_data.exit().remove();
      var node = node_data
        .enter().append("svg:g")
        .attr("class", "gene-group")
        .on("mouseover", nodeMouseover)
        .on("mouseout", nodeMouseout)
        .on("click", nodeMouseclick)
        .on("mousedown", nodeMousedown)
        .attr("id", function(d) { return d.id; })
      for( var type in gene_events ) node.on(type, gene_events[type]);
      event.geneadd(node.filter(function(d){return d;}));
      event.generemove(node_rm.filter(function(d){return d;}));
      event.genechange(node.filter(function(d){return d;}),
        node_rm.filter(function(d){return d;}),
        genes);

      node.append("svg:circle")
        .attr("class", "gene")
        .classed("gene-query", function(d) {return d.query;})
        .style("stroke-width", function(d) {return zoom.scale() < 1 ? 1/zoom.scale():1})
        .attr("r", r);

      node.append("svg:text")
        .style("pointer-events","none")
        .attr("class", "gene-name")
        .attr("text-anchor", "middle")
        .attr("transform","scale("+1/zoom.scale()+")")
        .attr("y", function(d) { return "-"+ (r(d)+5) * zoom.scale();})
        .text(geneText)
        .call(function(s){s.each(function(d) { d.bbox = this.getBBox(); })});

      node.insert("svg:rect", "text")
        .attr("rx", 5)
        .attr("ry", 5)
        .attr("x", function(d) { return d.bbox.x; })
        .attr("y", function(d) { return d.bbox.y; })
        .attr("width", function(d) { return d.bbox.width; })
        .attr("height", function(d) { return d.bbox.height; })
        .style("opacity",".5")
        .style("fill", "#FFF");

      // If nodes are added, release all nodes
      if ( node.filter(function(d){return d;})[0].length ) {
        selection.selectAll("circle.gene").each(function(g){
          if ( fixed )
            g.fixed = false;
        });
      }

      node_data.call(drag);

      applyGeneSharing();
      applyGeneSets();

      force.on("tick", function(e) {
        // Force query genes to the center of the layout
        // Re-calculate at initial ticks of layout
        if ( ( inner_layout || outer_layout ) && e.alpha > .08 ) {
          var points = selection.selectAll(".gene")
          //.filter(function(d) { return inner_layout ? d.query : true; })
            .data().map(function(g){return [g.x, g.y]});
          var c = d3.geom.polygon(d3.geom.hull(points)).centroid();
          var qgenes = selection.selectAll(".gene")
            .filter(function(d) { return inner_layout ? d.query : !d.query; })
            .each(function(d) {
              d.centroid = c;
              d.clusters = 1;
            });
        }

        // Move to centroid if exists
        node_data.each(function(d) {
          if ( !d.centroid ) return;
          var x = d.x - d.centroid[0]/d.clusters,
            y = d.y - d.centroid[1]/d.clusters,
            l = Math.sqrt(x * x + y * y);
          d.x -= x *= (l-r(d)*2)/l * e.alpha;
          d.y -= y *= (l-r(d)*2)/l * e.alpha;
        });
        node_data.each(collide(.5, nodes));
        node_data.attr('cx', function(d) {
          return d.x; });
        node_data.attr('cy', function(d) {
          return d.y; });
        node_data.attr("transform", function(d,i) {
          if ( bind_networks[0] && bind_networks[0].gene(d.id)
            && !isNaN(bind_networks[0].gene(d.id).x)) {
            var ref = bind_networks[0].gene(d.id);
            d.x = ref.x;
            d.px = ref.px;
            d.y = ref.y;
            d.py = ref.py;
          }
          var x = d.x;
          var y = d.y;
          return "translate(" + x + "," + y + ")";
        });
        link_data.attr("d", function(d) {
          return "M" + d.source.x + "," + d.source.y
            + "S" + d.inter.x + "," + d.inter.y
            + " " + d.target.x + "," + d.target.y;
        });

        // After layout, fix all nodes in place
        if ( e.alpha * .99 < .005 && e.alpha > 0 ) {
          selection.selectAll("circle.gene").each(function(g){
            if ( fixed )
              g.fixed = true;
          });
        }
        selection.selectAll("path.gs").data(gene_sets).attr("d", groupPath);
      });
    }

    function collide(alpha, nodes) {
      var queryPadding = inner_layout ? 30 : 5, padding = outer_layout ? 30 : 5;
      var quadtree = d3.geom.quadtree(nodes);
      return function(d) {
        var v = r(d) + 15 + Math.max(queryPadding, padding),
          nx1 = d.x - v,
          nx2 = d.x + v,
          ny1 = d.y - v,
          ny2 = d.y + v;
        quadtree.visit(function(quad, x1, y1, x2, y2) {
          if (quad.point && (quad.point !== d)) {
            var x = d.x - quad.point.x,
              y = d.y - quad.point.y,
              l = Math.sqrt(x * x + y * y),
              v = r(d) + r(quad.point) + (d.query ? queryPadding : padding);
            if (l < v) {
              l = (l - v) / l * alpha;
              d.x -= x *= l;
              d.y -= y *= l;
              quad.point.x += x;
              quad.point.y += y;
            }
          }
          return x1 > nx2 || x2 < nx1 || y1 > ny2 || y2 < ny1;
        });
      };
    }

    /*
     *  Functions for handling geneset visualization: add node shadows and hull convex paths
     */
    function applyGeneSets() {
      var gs_data = selection.selectAll("path.gs")
        .data(gene_sets, function(d) { return d.id; })
        .attr("d", groupPath);
      gs_data.exit().remove();
      var gs = gs_data.enter().insert("path","path.edge")
        .attr("d",groupPath)
        .attr("class","gs")
        .style("stroke",function(d) {return d.color;})
        .style("fill",function(d) {return d.color;})
        .style("stroke-width",40)
        .style("stroke-linejoin", "round")
        .style("stroke-opacity", "1")
        .style("opacity", ".1");

      // Reset
      selection.selectAll("circle.gene-shadow").remove();
      selection.selectAll("g.geneset")
        .selectAll("circle")
        .style("stroke","#AAA")
        .classed("geneset", false);

      selection.selectAll("g.gene-group")
        .each(function(d) {
          d.centroid = null;
          d.clusters = null; });

      for ( var i = 0; i < gene_sets.length; i++ ) {
        var gs = gene_sets[i];
        var c = centroid(gs);
        var genes = selection.selectAll("g.gene-group").filter(function(d) {
          return gs.genes.indexOf(d.id) != -1;
        });
        // no genes found
        if ( !genes[0].length ) continue;
        genes.classed("geneset",false);
        applyNodeHighlight(genes, gs.color);
        genes.classed("geneset",true);
        genes.each(function(d) { d.fixed = false; });

        if ( c != null )
          genes.each(function(d) {
            if ( !d.centroid ) {
              d.centroid = [0,0];
              d.clusters = 0;
            }
            d.centroid[0] += c[0];
            d.centroid[1] += c[1];
            d.clusters += 1;
          });
      }
      force.resume();
    }

    function applyNodeHighlight(node, color) {
      if ( node.classed("geneset") ) return;
      if ( !color ) color = node.select("circle.gene").style("stroke");
      if ( !color ) color = "#AAA";

      node.select("circle.gene").style("stroke",color);

      node.insert("svg:circle", "circle.gene")
        .attr("r",r)
        .attr("class","gene-shadow")
        .style("stroke",d3.rgb(color).brighter(1))
        .style("stroke-opacity", ".3")
        .style("stroke-width",10/zoom.scale());

      node.insert("svg:circle", "circle.gene")
        .attr("r",r)
        .attr("class","gene-shadow")
        .style("stroke",d3.rgb(color).brighter(.5))
        .style("stroke-opacity", ".5")
        .style("stroke-width",4/zoom.scale());
    }

    function removeNodeHighlight(node) {
      if ( node.classed("geneset") ) return;
      node.selectAll("circle.gene-shadow").remove();
    }

    function groupPath(d) {
      var points = d3.geom.hull(d.genes.map(function(g){
        var genes = selection.selectAll("g.gene-group")
          .filter(function(d) { return d.entrez == g; }).data();
        if ( genes.length ) return [genes[0].x, genes[0].y];
        else return null;
      }).filter(function(i){return i != null;}));

      if ( points.length )
        return "M" + points.join("L") + "Z";
      else
        return "";
    }

    function centroid(d) {
      var points = d.genes.map(function(g){
        var genes = selection.selectAll("g.gene-group")
          .filter(function(d) { return d.entrez == g; }).data();
        if ( genes.length ) return [genes[0].x, genes[0].y];
        else return null;
      }).filter(function(i){return i != null;});
      if ( points.length < 3 ) return null;
      return d3.geom.polygon(d3.geom.hull(points)).centroid();
    }

    function applyGeneSharing() {
      // clear stroke before setting
      selection.selectAll("circle.gene-overlap").remove();

      // set stroke color if node is visible in other networks
      selection.selectAll("g.gene-group").filter(function(d) {
        for ( var i in bind_networks ) {
          var net = bind_networks[i];
          if ( net === my ) continue;
          if ( net.gene(d.id) && (net.gene(d.id).draw_degree > 0 ||
            net.gene(d.id).query) )
            return true;
        }
        return false;
      }).append("svg:circle", "circle.gene")
        .style("stroke-width",2/zoom.scale())
        .attr("class", "gene-overlap")
        .attr("r",function(d){ return r(d)-3; });
    }

    /*
     * Functions for handling zooming and panning of network view
     */
    function updateZoom(transition) {
      if (Number.isNaN(zoom.scale())) return;

      var select = selection;
      if ( transition )
        select = selection.transition().duration(transition);

      // Update translate and zoom to new values
      select.attr("transform","translate("+zoom.translate()+")scale("+zoom.scale()+")");

      // Keep text size the same when zooming in
      if ( zoom.scale() < 1 ) {
        select.selectAll("text")
          .attr("transform","scale("+1/zoom.scale()+")")
          .attr("y", function(d) { return "-"+ (r(d)+5) * zoom.scale();})
        select.selectAll("circle.gene")
          .style("stroke-width", 1/zoom.scale())
      }
      else {
        select.selectAll("text")
          .attr("transform","scale(1)")
          .attr("y", function(d) { return "-"+ (r(d)+5);})
        select.selectAll("circle.gene")
          .style("stroke-width", 1)
      }
    }

    function fitZoom(transition) {
      var min_x = d3.min(selection.selectAll('text,g,circle').data(),function(d){return d.x;});
      var max_x = d3.max(selection.selectAll('text,g,circle').data(),function(d){return d.x;});
      var min_y = d3.min(selection.selectAll('text,g,circle').data(),function(d){return d.y;});
      var max_y = d3.max(selection.selectAll('text,g,circle').data(),function(d){return d.y;});
      var dx = max_x - min_x;
      var dy = max_y - min_y;
      var x = (min_x + max_x) / 2;
      var y = (min_y + max_y) / 2;
      var scale = .85 / Math.max(dx / width, dy / height);
      scale = Math.min(scale, 1.2);
      var translate = [width / 2 - scale * x, height / 2 - scale * y];
      zoom.scale(scale);
      zoom.translate(translate);
      updateZoom(transition ? transition : 1000);
    }

    function zoomed() {
      updateZoom();
    }

    function dragstarted(d) {
      d3.event.sourceEvent.stopPropagation();
    }

    function dragged(d) {
      d3.select(this).attr("cx", d.x = d3.event.x).attr("cy", d.y = d3.event.y);
    }

    function dragended(d) {
      d3.select(this).classed("dragging", false);
    }

    /*
     * Functions for handling mouse events for edges and nodes
     */
    function linkMouseover(d) {
      d3.select(this).style("stroke-width",12).style("cursor","pointer");
      var genes = selection.selectAll("circle.gene").filter(function(node,i) {
        return node.id == d.source.id || node.id == d.target.id;
      }).style("stroke-dasharray","6, 3");

      if ( bind_networks.length ) {
        for ( var i=0, n=bind_networks.length; i<n; i++ ) {
          if ( bind_networks[i] == my ) continue;

          bind_networks[i].selection().selectAll("circle.gene")
            .filter(function(node,i) {
              return node.id == d.source.id || node.id == d.target.id;
            }).style("stroke-dasharray","6, 3");

          bind_networks[i].selection().selectAll("path.edge")
            .filter(function(edge,i) {
              return (edge.source.id == d.source.id &&
                edge.target.id == d.target.id) ||
                (edge.source.id == d.target.id && edge.target.id == d.source.id);
            }).style("stroke-width",12).style("cursor","pointer");
        }
      }
    }

    function linkMouseout(d) {
      if ( d.selected ) return;

      d3.select(this).style("stroke-width", w);
      var genes = selection.selectAll("circle.gene").filter(function(node,i) {
        return node.id == d.source.id || node.id == d.target.id;
      }).style("stroke-dasharray",null);

      if ( bind_networks.length ) {
        for ( var i=0, n=bind_networks.length; i<n; i++ ) {
          if ( bind_networks[i] == my ) continue;

          bind_networks[i].selection().selectAll("circle.gene")
            .filter(function(node,i) {
              return node.id == d.source.id || node.id == d.target.id;
            }).style("stroke-dasharray",null);

          bind_networks[i].selection().selectAll("path.edge")
            .filter(function(edge,i) {
              if ( edge.selected ) {
                return false;
              }
              else
                return (edge.source.id == d.source.id &&
                  edge.target.id == d.target.id) ||
                  (edge.source.id == d.target.id &&
                    edge.target.id == d.source.id);
            }).style("stroke-width",w);;
        }
      }
    }

    function nodeMouseover(d) {
      removeNodeHighlight(d3.select(this));
      applyNodeHighlight(d3.select(this));

      selection.selectAll("path.edge").filter(function(edge,i) {
        return ( edge.source.id == d.id || edge.target.id == d.id );
      }).style("stroke-dasharray","6, 3");

      if ( bind_networks.length ) {
        for ( var i=0, n=bind_networks.length; i<n; i++ ) {
          bind_networks[i].selection().selectAll("path.edge").filter(function(edge,i) {
            return ( edge.source.id == d.id || edge.target.id == d.id );
          }).style("stroke-dasharray","6, 3");
        }
      }
    }

    function nodeMouseout(d) {
      removeNodeHighlight(d3.select(this));

      var selected = selection.selectAll("path.edge").filter(function(edge,i) {
        return ( edge.source.id == d.id || edge.target.id == d.id );
      });
      selected.style("stroke-dasharray",null);

      if ( bind_networks.length ) {
        for ( var i=0, n=bind_networks.length; i<n; i++ ) {
          bind_networks[i].selection().selectAll("path.edge").filter(function(edge,i) {
            return ( edge.source.id == d.id || edge.target.id == d.id );
          }).style("stroke-dasharray",null);
        }
      }
    }

    function nodeMouseclick(d) {
      d.fixed = true;
    }

    function nodeMousedown(d) {
      d.fixed = true;
      if ( bind_networks.length ) {
        var tmp = bind_networks[0];
        bind_networks[bind_networks.indexOf(my)] = tmp;
        bind_networks[0] = my;
        for ( var i=0, n=bind_networks.length; i<n; i++ ) {
          bind_networks[i].resume();
        }
      }
    }

    function addLegend(scale) {
      if ( ! scale ) scale = .8;

      var legend_svg = svg.append("svg:svg")
        .attr("class","network_legend")
        .attr("width", width*scale)
        .attr("height", 20)
        .attr("x", width*(1-scale)*.5)
        .attr("y", height-25);

      var legend = legend_svg.append("svg:defs")
        .append("svg:linearGradient")
        .attr("id", "legend")
        .attr("x1","0%")
        .attr("y1","0%")
        .attr("x2","100%")
        .attr("y2","0%")
        .attr("spreadMethod", "pad");

      for ( var i=0; i<1; i+=.05 ) {
        legend.append("svg:stop")
          .attr("offset", parseInt(i*100)+"%")
          .style("stop-color",
            edgeColor(options.start_edge + (1-options.start_edge)*i))
          .style("stop-opacity", .8);
      }

      legend_svg.append("svg:rect")
        .style("cursor","move")
        .attr("width", width*scale-2)
        .attr("height", 20)
        .attr("y",12)
        .attr("x", 1)
        .attr("fill", "url(#legend)")

      var text = legend_svg.append("svg:text")
        .attr("y", 11)
        .text(options.start_edge.toFixed(1));

      legend_svg.append("svg:text")
        .attr("y", 11)
        .attr("x", width*scale - text.node().getBBox().width)
        .text("1.0");

      legend_svg.append("svg:text")
        .attr("y", 11)
        .attr("x", width*scale*.5 - text.node().getBBox().width/2)
        .text("0.5");
    }

    function removeLegend() {
      d3.selectAll("svg.network_legend").remove();
    }

    /*
     * Public functions for setting/getting attributes
     */
    my.draw = function() {
      draw(draw_genes, draw_edges);
      var drawn = !svg.select("svg.legend").empty();
      if ( legend && !drawn ) addLegend();
      else if ( !legend && drawn ) removeLegend();
    };

    my.updateStyling = function() {
      applyGeneSharing();
      applyGeneSets();
    };

    my.showLegend = function(x) {
      if (!arguments.length) x = true;
      legend = x;
      return my;
    };

    my.filter = function(edge_cut, node_cut) {
      var gene_filter = function(d) {
        return d.query || d.rank < node_cut;
      };

      var edge_filter = function(d) {
        return d.weight > edge_cut && gene_filter(d.target)
          && gene_filter(d.source);
      };

      draw_genes = genes.filter(gene_filter);
      draw_edges = edges.filter(edge_filter);

      // Remove hanging nodes: calculate node degrees to the filtered edges
      var n = genes.length,
        m = draw_edges.length,
        edge, i;
      for( i = 0; i < n; i++ ) {
        genes[i].draw_degree = 0;
      }
      for( i = 0; i < m; i++ ) {
        edge = draw_edges[i];
        edge.source.draw_degree += edge.weight;
        edge.target.draw_degree += edge.weight;
      }
      draw_genes = draw_genes.filter(function(d) {
        return d.draw_degree > 0 || d.query; })

      return my;
    };

    my.text = function(full) {
      var network = full ? edges : draw_edges;
      var text = 'GENE1,GENE2,WEIGHT\n';
      var i, n = network.length;
      for ( i = 0; i < n; i++ ) {
        text += network[i].source.standard_name + ',';
        text += network[i].target.standard_name + ',';
        text += network[i].weight;
        text += '\n';
      }
      return text;
    }

    my.html = function() {
      function styles(dom) {
        var used = "";
        var sheets = document.styleSheets;
        for (var i = 0; i < sheets.length; i++) {
          // http://stackoverflow.com/questions/21642277/security-error-the-operation-is-insecure-in-firefox-document-stylesheets
          // In Firefox, if stylesheet originates from a different domain
          // cssRules will throw an error
          try {
            var rules = sheets[i].cssRules;
            if ( !rules ) continue;
            for (var j = 0; j < rules.length; j++) {
              var rule = rules[j];
              if (typeof(rule.style) != "undefined") {
                var elems = dom.querySelectorAll(rule.selectorText);
                if (elems.length > 0) {
                  used += rule.selectorText + " { " + rule.style.cssText + " }\n";
                }
              }
            }
          } catch(e) {
            // SecurityError is specific to Firefox, thrown
            // when cssRules is from a non-origin domain
            // SyntaxError is specific to Safari
            continue
          }
        }
        var s = document.createElement('style');
        s.setAttribute('type', 'text/css');
        s.innerHTML = "<![CDATA[\n" + used + "\n]]>";

        var defs = document.createElement('defs');
        defs.appendChild(s);
        dom.insertBefore(defs, dom.firstChild);
      }

      addLegend();
      var node = svg.attr("version",1.1)
        .attr("xmlns","http://www.w3.org/2000/svg")
        .node().cloneNode(true);
      styles(node);
      var html = node.outerHTML;
      removeLegend();
      return html
    };

    my.image = function() {
      var image = new Image();
      image.src = 'data:image/svg+xml;base64,' + window.btoa(my.html());
      return image;
    }

    my.onGene = function(type, listener) {
      if ( typeof listener == "function" )
        gene_events[type] = listener;
      return my;
    };

    my.onEdge = function(type, listener) {
      if ( typeof listener == "function" )
        edge_events[type] = listener;
      return my;
    };

    my.edgeColor = function(x) {
      if (!arguments.length) return edgeColor;
      if ( typeof x == "function" ) edgeColor = x;
      else edgeColor = function(d) { return x; };
      return my;
    };

    my.geneRadius = function(x) {
      if (!arguments.length) return r;
      if ( typeof x == "function" ) r = x;
      else r = function(d) { return x; };
      return my;
    };

    my.edgeWidth = function(x) {
      if (!arguments.length) return w;
      if ( typeof x == "function" ) w = x;
      else w = function(d) { return x; };
      return my;
    };

    my.geneText = function(x) {
      if (!arguments.length) return geneText;
      if ( typeof x == "function" ) geneText = x;
      else geneText = function(d) { return x; };
      return my;
    };

    my.highlightGenes = function(x) {
      var genes = {};
      for ( var i=0, n=x.length; i<n; i++ ) {
        genes[x[i]] = true;
      }
      var nodes = d3.selectAll('.genes').filter(function(d) { return genes[d];});
    };

    my.selection = function() {
      return selection;
    };

    my.drawGenes = function() {
      return draw_genes;
    };

    my.drawEdges = function() {
      return draw_edges;
    };

    my.height = function(x) {
      if (!arguments.length) return height;
      height = x;
      return my;
    };

    my.width = function(x) {
      if (!arguments.length) return width;
      width = x;
      return my;
    };

    my.bindNetworks = function(x) {
      if (!arguments.length) return bind_networks;
      bind_networks = x;
      return my;
    };

    my.resume = function() {
      force.resume();
    };

    my.gene = function(x) {
      return gene_map[x];
    };

    my.genes = function(x) {
      if (!arguments.length) return genes;
      genes = x;
      draw_genes = x;
      for( var i = 0, n = genes.length; i < n; i++ ) {
        gene_map[genes[i].id] = genes[i];
      }
      return my;
    };

    my.edges = function(x) {
      if (!arguments.length) return edges;
      edges = x;
      draw_edges = x;
      return my;
    };

    my.geneSets = function(x) {
      if (!arguments.length) return gene_sets;
      gene_sets = x;
      return my;
    };

    my.degreeCorrect = function(x) {
      if (!arguments.length) return degree_correct;
      degree_correct = x;

      // Sort nodes according to background corrected degree
      // Store corresponding ranks
      if ( degree_correct )
        genes.sort(function(a,b){return b.query_degree/b.degree
          -a.query_degree/a.degree;})
      else
        genes.sort(function(a,b){return b.query_degree
          -a.query_degree;})

      for( var i = 0, n = genes.length; i < n; i++ )
      { genes[i].rank = i; }

      return my;
    };

    my.stop = function() {
      if ( force ) force.stop();
    };

    my.scale = function(x) {
      if (!arguments.length) return zoom.scale();
      zoom.scale([x]);
      updateZoom();
      return my;
    };

    my.translate = function(x) {
      if (!arguments.length) return zoom.translate();
      zoom.translate(x);
      updateZoom();
      return my;
    };

    my.fitZoom = function() {
      fitZoom();
      return my;
    };

    my.fixed = function(x) {
      if (!arguments.length) return fixed;
      fixed = x;
      selection.selectAll('.gene').each(function(d) {
        d.fixed = x;
      });
      return my;
    }

    my.innerLayout = function(x) {
      if (!arguments.length) return inner_layout;
      inner_layout = x;
      my.draw();
      return my;
    }

    my.outerLayout = function(x) {
      if (!arguments.length) return outer_layout;
      outer_layout = x;
      my.draw();
      return my;
    }

    my.getMatchingBindNetworksEdge = function(d) {
      var edges = {};
      for ( var i=0, n=bind_networks.length; i<n; i++ ) {
        var data = bind_networks[i].selection().selectAll("path.edge").filter(function(edge,i) {
          return (edge.source.id == d.source.id && edge.target.id == d.target.id) ||
            (edge.source.id == d.target.id && edge.target.id == d.source.id);
        }).data();
        if ( data.length )
          edges[i] = data[0];
      }
      return edges;
    };

    my.clearEdgeSelection = function() {
      var selected = selection.selectAll("path.edge").filter(function(edge,i) {
        return edge.selected;
      });
      selected.each(function(edge) { edge.selected = false; });
      if ( selected[0].length )
        linkMouseout.bind(selected[0][0])(selected.data()[0]);
    };

    my.clearNodeSelection = function() {
      var selected = selection.selectAll("g.gene-group").filter(function(node,i) {
        return node.selected;
      });
      selected.each(function(node) { node.selected = false; });
      if ( selected[0].length )
        nodeMouseout.bind(selected[0][0])(selected.data()[0]);
    };

    my.selectNode = function(d) {
      d.fixed = true;
      d.selected = true;
    };

    my.selectEdge = function(d) {
      d.source.fixed = true;
      d.target.fixed = true;
      var edge = selection.selectAll("path.edge").filter(function(edge,i) {
        return edge.id == d.id;
      });
      linkMouseover.bind(edge[0][0])(d);
      d.selected = true;

      if ( bind_networks.length ) {
        for ( var i=0, n=bind_networks.length; i<n; i++ ) {
          bind_networks[i].selection().selectAll("path.edge").each(function(edge,i) {
            if ( (edge.source.id == d.source.id &&
              edge.target.id == d.target.id) ||
              (edge.source.id == d.target.id && edge.target.id == d.source.id) ) {
              edge.source.fixed = true;
              edge.target.fixed = true;
              edge.selected = true;
            }
          });
        }
      }
    };

    return d3.rebind(my, event, "on");
  } // network

})();
